import React from 'react';
import { useTheme } from '@material-ui/core';

const HeartHands = () => {
  const {
    common: { white },
    primary: { main },
  } = useTheme().palette;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-20 -10 230 100" fill="none">
      <g>
        <path
          d="M93.6 17.84c.4-3.2 1.15-6.36 2.27-9.39.71-1.56 4-3.45 6.53-5.1 2.53-1.65 4.91-3 6-3 1.09 0 5.76 2.45 8.41 4.45 2.65 2 8.21 6 10.28 6.78 2.07.78 2.8.41 5 4 1.92 3.14 12.61 15.33 16.34 19.41 3.73 4.08 7.41 5.72 12.32 12.23 4.91 6.51 24.66 28.61 24.66 28.61"
          stroke={main}
        />
        <path d="M94.93 15a1.12 1.12 0 0 0-.71-.83l-1.22 4h.52L94.93 15Z" stroke={main} />
        <path
          d="M125.62 14.2a6.7 6.7 0 0 1-2.23-.79c-.62-.36-8-4.65-10.84-6.66-5.67-4-6.07-1.62-10.23 0s-5.4 2.88-6.42 5.87c-1.02 2.99-2.05 4.46-2.52 6-.47 2.34 2.41 2.18 4.12.91s4-5.61 4-5.61a15.2 15.2 0 0 0 6.53-.81c2.65 3.81 8 6.92 8 6.92.72 5.5 4.58 11.39 4.58 11.39-.65 5.11-2.75 6.4-4.73 8.46-1.98 2.06-6.18 3.9-11.6 5s-11.46 5.36-10 9.59c1.46 4.23 4.1.45 6.47-.49s3.79-.45 8-1.17c10.35-2.08 15.82 1.1 21.3 3.84 3.35 1.63 7.17 2 10.77 1.06 8.66 8 17.31 26.91 19.18 31M108.06 13.13l.94-1.87"
          stroke={main}
        />
        <path
          d="M95.47 13.77a2.35 2.35 0 0 1 .19 2.28c-.55 1.34-1.3 2.85-1.3 2.85s-.89.32-1.2.09l2.31-5.22ZM96.39 56.41c-1.38-.66-1.28-3.39-1.28-3.39s2.85-1.69 3.57-1.93c.72-.24 2 1.75 1.37 3.26l-3.66 2.06ZM116.06 20.06c1.5.22 3.04.05 4.45-.51M101.53 13.94a4.7 4.7 0 0 0-.6-1.59M108.61 51.76a3.52 3.52 0 0 0 .6-2.85M120.64 31.45c.1-.66.1-1.34 0-2M92.4 17.84c-.4-3.2-1.15-6.36-2.27-9.39-.71-1.56-4-3.45-6.53-5.1-2.53-1.65-4.91-3-6-3-1.09 0-5.76 2.45-8.41 4.45-2.65 2-8.21 6-10.28 6.78-2.07.78-2.8.41-5 4C52 18.72 41.29 30.91 37.56 35c-3.73 4.09-7.41 5.72-12.32 12.23C20.33 53.74.58 75.84.58 75.84"
          stroke={main}
        />
        <path d="M91.07 15a1.12 1.12 0 0 1 .71-.83l1.22 4h-.52L91.07 15Z" stroke={main} />
        <path
          d="M60.38 14.2c.78-.13 1.54-.4 2.23-.79.62-.36 8-4.65 10.84-6.66 5.67-4 6.07-1.62 10.23 0s5.4 2.88 6.42 5.87c1.02 2.99 2.05 4.46 2.52 6 .47 2.34-2.41 2.18-4.12.91s-4-5.61-4-5.61a15.2 15.2 0 0 1-6.53-.81c-2.65 3.81-8 6.92-8 6.92-.72 5.5-4.58 11.39-4.58 11.39.65 5.11 2.75 6.4 4.73 8.46 1.98 2.06 6.18 3.9 11.6 5s11.46 5.36 10 9.59c-1.46 4.23-4.1.45-6.47-.49s-3.79-.45-8-1.17c-10.35-2.08-15.82 1.1-21.3 3.84-3.35 1.63-7.17 2-10.77 1.06-8.66 8-17.31 26.91-19.18 31M77.94 13.13 77 11.26"
          stroke={main}
        />
        <path
          d="M90.53 13.77a2.35 2.35 0 0 0-.19 2.28c.55 1.34 1.3 2.85 1.3 2.85s.89.32 1.2.09l-2.31-5.22ZM89.61 56.41c1.38-.66 1.28-3.39 1.28-3.39s-2.85-1.69-3.57-1.93c-.72-.24-2 1.75-1.37 3.26l3.66 2.06ZM69.94 20.06c-1.5.22-3.04.05-4.45-.51M84.47 13.94c.1-.56.3-1.1.6-1.59M77.39 51.76a3.53 3.53 0 0 1-.6-2.85M65.36 31.45c-.1-.66-.1-1.34 0-2"
          stroke={main}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="186" height="90" fill={white} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HeartHands;
